import AllExperiments from '../views/AllExperiments.vue';

const info = {
	parameters: {
		default: `Information regarding to parameters will be shown here.\n Parameters related to the app config can be displayed and edited in this section`,
		priority: `Priority, parameter içinde audience’lara göre belirlenen değerler olduğunda ve kullanıcının birden fazla audience içine girdiği durumda kullanıcıya hangi değerin gösterileceğini belirler. Bu alana girilen sayı büyüdükçe değerin önceliği artacaktır. En büyük sayının girildiği priority alanına sahip değer o satırdaki audience’a birinci öncelikli olarak gösterilir. `,
		tag: `Bu alan kullanılarak “Edit Tag” alanı kullanılarak parametreler etiketlenebilir. `
	},
	isl: '',
	experiments: '',
	audiences: '',
	allExperiments: {
		default:
			'This page displays all the experiments across all apps. You can use filtering options below.\nTo get the experiments in an exact date, set both start and end time filters to same date.'
	}
};

export default info;
